/*
 * Testimonial content resolver — CMS-managed customer reviews (DIT-334).
 *
 * `testimonialsFor(locale)` returns the CMS testimonials published for a locale
 * (hydrated at build by scripts/fetch-cms-content.mjs into
 * `_generated/cms-testimonials.ts`), or `[]` when none are authored yet — the
 * caller (HomeNew) then keeps its baked i18n hero reviews. No cross-locale
 * fallback: the set is per (market × language), so an empty locale must NOT
 * borrow another market's (or English's) reviews. Pure data only (NFR10).
 */
import { CMS_TESTIMONIALS } from "../_generated/cms-testimonials";

export interface Testimonial {
  slug: string;
  author: string;
  /** Avatar URL (uploaded via the CMS); may be empty → caller supplies a default. */
  photo: string;
  role: string;
  quote: string;
}

/** CMS testimonials for a locale (empty array when none are published yet). */
export const testimonialsFor = (locale?: string): Testimonial[] =>
  (locale && CMS_TESTIMONIALS[locale]) || [];
